import INIT_STATE from "../init/state";
import { CHANGE_INIT } from "../types/types";

export function mainReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case CHANGE_INIT: return {...state, init: action.value};
        default: return state;
    }
}